import { useEffect, useState } from "react";
import { API, http } from "@/lib/api";
import { MaskLine, SectionLabel } from "@/components/site/Reveal";
import { PostCard } from "@/components/site/JournalTeaser";

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    document.title = "Insights — Scale Solutions by Sadiya";
    if (!API) {
      setPosts([]);
      return undefined;
    }
    let alive = true;
    http.get("/posts").then((r) => {
      if (alive) setPosts(Array.isArray(r?.data) ? r.data : []);
    }).catch(() => alive && setPosts([]));
    return () => { alive = false; };
  }, []);

  return (
    <main className="bg-[#F6F2E8] min-h-screen pt-[72px]" data-testid="blog-page">
      <section className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 sm:pt-28 pb-14 border-b border-[#D8CFBC]">
        <SectionLabel index="—">Insights</SectionLabel>
        <h1 className="font-display mt-8 text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-[-0.02em] text-[#221F1B]" data-testid="blog-headline">
          <MaskLine>Notes from the</MaskLine>
          <MaskLine delay={0.12} className="italic text-[#16302B]">operating floor.</MaskLine>
        </h1>
        <p className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-[#5C564E]">
          Perspectives on building, scaling, franchising, and bringing international beauty &amp; wellness brands to India.
        </p>
      </section>
      <section className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12 py-16 sm:py-24">
        {posts === null && <p className="text-[#5C564E]" data-testid="blog-loading">Loading articles…</p>}
        {posts?.length === 0 && <p className="font-display italic text-xl text-[#5C564E]" data-testid="blog-empty">New articles are on their way.</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-testid="blog-post-list">
          {(posts || []).map((p, i) => <PostCard key={p.id} post={p} i={i % 3} />)}
        </div>
      </section>
    </main>
  );
}
